import { useContext } from "react";

import { DlpFlowContext } from "../context/DlpFlowContext";

export const useDlpFlowContext = () => {
  const context = useContext(DlpFlowContext);

  if (context === undefined) {
    throw new Error("'useDlpContext' must be used within a 'DlpFlowProvider'");
  }

  return context;
};
